import { Trans, useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import { getWidgetText } from './helpers'
import * as Styles from './styles'

export const Widget = ({
  backgroundColor,
  textColor,
  linkColor,
  enabledForExchanges,
  enabledForRefunds,
  customTexts,
  useCustomText,
  language,
}) => {
  const { t } = useTranslation()

  return (
    <Styles.Container backgroundColor={backgroundColor} textColor={textColor} linkColor={linkColor}>
      <img src={`/logos/logo_light.svg`} alt="Reveni logo" />
      <Text type="bodySRegular">
        {useCustomText ? (
          customTexts?.[language]
        ) : (
          <>
            {t('Si tienes que realizar')} {getWidgetText(enabledForRefunds, enabledForExchanges, Trans)},{' '}
            {t('hazlo rápido y fácil con Reveni.')}{' '}
          </>
        )}
        {'  '}
        <a href="https://reveni.com" target="_blank" rel="noreferrer">
          {t('Más info')}
        </a>
      </Text>
    </Styles.Container>
  )
}
